import { SET_USER, CLEAR_USER } from "./userActions";

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

let initialState = {
  user: null,
  token: null,
};

const cookieValue = getCookie("userInfo");
const tokenValue = getCookie("token");

if (cookieValue) {
  try {
    const parsedUser = JSON.parse(cookieValue);
    initialState.user = parsedUser || null;
  } catch (error) {}
}

if (tokenValue) {
  initialState.token = tokenValue;
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      const { user, token } = action.payload;
      setCookie("userInfo", JSON.stringify(user), 30);
      setCookie("token", token, 30);
      return { ...state, user, token };
    case CLEAR_USER:
      setCookie("userInfo", "", -1);
      setCookie("token", "", -1);
      return { ...state, user: null, token: null };

    default:
      return state;
  }
};

export default userReducer;
